import { Context } from 'react-intl/src/components/injectIntl';
import { assign, createMachine } from 'xstate';
import { ApplicationError } from '../../components/ApplicationErrorBoundary/errors/ApplicationError';
import { ExpenseCheckService, expenseCheckService } from '../services/expense-check';
import { ExpenseCheckResponse } from '../services/expense-check-client';

export type ExpenseCheckMachineProps = {
  externalReference?: string;
};

type Context = {
  response: ExpenseCheckResponse | undefined;
  error: ApplicationError | undefined;
};

type Service = {
  createReport: { data: ExpenseCheckResponse };
};

export const getMachine = (
  { externalReference }: ExpenseCheckMachineProps,
  service: ExpenseCheckService = expenseCheckService
) =>
  createMachine(
    {
      predictableActionArguments: true,
      id: 'serviceMachine',
      initial: 'auth',
      schema: {
        context: {} as Context,
        services: {} as Service,
      },
      context: {
        error: undefined,
        response: undefined,
      },
      tsTypes: {} as import('./expenseCheckMachine.typegen').Typegen0,
      states: {
        auth: {
          on: {
            CREDENTIALS: {
              target: 'LOADING',
            },
          },
        },
        LOADING: {
          invoke: {
            id: 'createReport',
            src: 'createReport',
            onDone: {
              target: 'SUCCESS',
              actions: 'saveResponse',
            },
            onError: {
              target: 'ERROR',
              actions: 'saveError',
            },
          },
        },
        SUCCESS: {
          type: 'final',
        },
        ERROR: {
          type: 'final',
        },
      },
    },
    {
      services: {
        createReport: () => service.createReport({ externalReference }),
      },
      actions: {
        saveResponse: assign({
          response: (_, event) => event.data,
        }),
        saveError: assign({
          error: (_, event) => event.data as ApplicationError,
        }),
      },
    }
  );
